import angular from 'angular';
import { mentionableComponent } from './mentionableComponent';
import '../richtext/richtextModule';

angular.module('sh.mentionable', ['sh.richtext']).component('shMentionable', mentionableComponent());
